<script>
import options from "./CategoryPicker.options";
export default options;
</script>

<template>
  <!-- saving for future, for now it will always be a slider also on desktop
    <section data-desktop class="kb-category-picker" :class="{'kb-category-picker--hide': slider }">

      <ul class="kb-category-picker__thumbnail-list">

        <template v-for="category in categories" :key="category.url">

          <li class="kb-category-picker__thumbnail-list-item">
            <a class="kb-category-picker__thumbnail-list-item-link" :href="category.url">
                <figure class="kb-image-module">
                  <div class="kb-image-module__image-container">
                    <picture class="kb-image-module__image">
                      <source :srcset="category.src" media="(min-width:1024px)">
                      <source :srcset="category.src" media="(min-width: 768px)">
                      <source :srcset="category.src" media="(min-width: 376px)">
                      <source :srcset="category.src" media="(max-width: 376px)">
                      <img :src="category.src" :alt="category.alt">
                    </picture>
                  </div>
                </figure>
                <p class="kb-category-picker__thumbnail-list-item-text">{{ category.text }}</p>
            </a>
          </li>

        </template>
      </ul>
    </section> -->

  <section class="kb-category-picker kb-category-picker__slider">

    <h2 class="kb-content-carousel__title" id="content-carousel-title">{{getLabel('title')}}</h2>

    <div class="glide kb-category-picker__glide" :id="glideId">

      <div class="kb-content-carousel__controls" data-glide-el="controls">
        <button class="kb-content-carousel__arrow" data-glide-dir="<" aria-controls="content-carousel-slides" aria-label="Forrige">
          <div class="kb-ui-icon kb-ui-icon--ui-chevron-down"></div>
        </button>
        <button class="kb-content-carousel__arrow" data-glide-dir=">" aria-controls="content-carousel-slides" aria-label="Næste">
          <div class="kb-ui-icon kb-ui-icon--ui-chevron-up"></div>
        </button>
      </div>

      <div
        class="glide__track kb-category-picker__glide__track"
        data-glide-el="track"
      >
        <ul class="glide__slides">
          <template v-for="(category, index) in categories" :key="index">
            <li
              class="kb-category-picker__slider__content glide__slide kb-category-picker__thumbnail-list-item"
            >
              <a
                class="kb-category-picker__thumbnail-list-item-link"
                :href="category.url"
              >
                <figure class="kb-image-module">
                  <div class="kb-image-module__image-container">
                    <picture class="kb-image-module__image">
                      <source
                        :srcset="category.src"
                        media="(min-width:1024px)"
                      />
                      <source
                        :srcset="category.src"
                        media="(min-width: 768px)"
                      />
                      <source
                        :srcset="category.src"
                        media="(min-width: 376px)"
                      />
                      <source
                        :srcset="category.src"
                        media="(max-width: 376px)"
                      />
                      <img :src="category.src" :alt="category.alt || ''" />
                    </picture>
                  </div>
                </figure>
                <p class="kb-category-picker__thumbnail-list-item-text">
                  {{ category.text }}
                </p>
              </a>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </section>
</template>
